var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStatistic = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1875 -1279)"
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0,
  width: 24,
  height: 24,
  transform: "translate(1899 1279) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  width: 2,
  height: 16,
  rx: 1,
  transform: "translate(1892 1283)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  width: 2,
  height: 11,
  rx: 1,
  transform: "translate(1888 1288)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  width: 2,
  height: 4,
  rx: 1,
  transform: "translate(1884 1295)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  width: 2,
  height: 8,
  rx: 1,
  transform: "translate(1880 1291)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatistic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/statistic.494562a5.svg";
export { ForwardRef as ReactComponent };